var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let CategoryModel = class CategoryModel {
    constructor() {
        this.code = 'ALL_CATEGORIES';
        this.name = 'All Categories';
        this.id = -1;
    }
};
__decorate([
    JsonProperty("code", String)
], CategoryModel.prototype, "code", void 0);
__decorate([
    JsonProperty("name", String)
], CategoryModel.prototype, "name", void 0);
__decorate([
    JsonProperty("id", Number)
], CategoryModel.prototype, "id", void 0);
CategoryModel = __decorate([
    JsonObject("CategoryModel")
], CategoryModel);
export { CategoryModel };
//# sourceMappingURL=category.model.js.map